/**
 * 质控多网关 baseURL（与 businesssystem 一致）
 * 开发 / 生产统一：/sit-api/{gatewayPath}
 */

const GATEWAY_ROOT = '/sit-api'

export const QC_API_BACKENDS = {
  roadcqcOldBackend: {
    legacyDevPrefix: '/api',
    gatewayPath: '/roadcqcold-backend',
    desc: '旧质控后端'
  },
  unisystem: {
    legacyDevPrefix: '/apci',
    gatewayPath: '/unisystem',
    desc: '统一认证 / 系统管理'
  },
  roadcqcBackend: {
    legacyDevPrefix: '/apcj',
    gatewayPath: '/roadcqc-backend',
    desc: '质控主后端'
  },
  roadcqcOldApp: {
    legacyDevPrefix: '/apis',
    gatewayPath: '/roadcqcold-app',
    desc: '旧质控 App 后端'
  },
  hwCons: {
    legacyDevPrefix: '/apcg',
    gatewayPath: '/hw-cons',
    desc: '养护施工后端'
  },
  hwSpace: {
    legacyDevPrefix: '/apcs',
    gatewayPath: '/hw-space',
    desc: '养护切割服务'
  },
  roadcqcApp: {
    legacyDevPrefix: '/apcp',
    gatewayPath: '/roadcqc-app',
    desc: '质控移动端'
  }
}

export function getQcGatewayRoot () {
  return GATEWAY_ROOT.replace(/\/$/, '')
}

export function resolveQcBackendBaseUrl (backend) {
  if (!backend) return ''
  return `${getQcGatewayRoot()}${backend.gatewayPath}`
}

export function resolveQcBackendBaseUrlByKey (backendKey) {
  const backend = QC_API_BACKENDS[backendKey]
  if (!backend) {
    throw new Error(`未知质控后端: ${backendKey}`)
  }
  return resolveQcBackendBaseUrl(backend)
}

function stripLegacyPrefix (backend, path) {
  let rest = path
  const legacyPrefixes = [
    backend.legacyDevPrefix,
    backend.gatewayPath,
    `${getQcGatewayRoot()}${backend.gatewayPath}`
  ].filter(Boolean)

  for (const prefix of legacyPrefixes) {
    if (rest === prefix) return '/'
    if (rest.startsWith(prefix + '/')) {
      rest = rest.slice(prefix.length) || '/'
      break
    }
  }
  return rest
}

export function withGatewayPrefix (backendKey, path) {
  if (!path) return path
  if (/^https?:\/\//i.test(path)) return path

  const backend = QC_API_BACKENDS[backendKey]
  if (!backend) return path

  const base = resolveQcBackendBaseUrl(backend).replace(/\/$/, '')
  const fullPrefix = `${getQcGatewayRoot()}${backend.gatewayPath}`
  let rest = String(path)

  if (rest === fullPrefix || rest.startsWith(fullPrefix + '/')) {
    return rest
  }

  rest = stripLegacyPrefix(backend, rest)
  if (!rest.startsWith('/')) rest = `/${rest}`
  return `${base}${rest}`
}

export const roadcqcBackendUrl = (path) => withGatewayPrefix('roadcqcBackend', path)
export const hwConsUrl = (path) => withGatewayPrefix('hwCons', path)
export const hwSpaceUrl = (path) => withGatewayPrefix('hwSpace', path)
export const roadcqcOldBackendUrl = (path) => withGatewayPrefix('roadcqcOldBackend', path)
export const roadcqcOldAppUrl = (path) => withGatewayPrefix('roadcqcOldApp', path)
export const roadcqcAppUrl = (path) => withGatewayPrefix('roadcqcApp', path)
export const unisystemUrl = (path) => withGatewayPrefix('unisystem', path)



// WEBPACK FOOTER //
// ./src/utils/qcGatewayBase.js